export const LinkIcon = (
  <svg className="size-6" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.0649 25.4605H24.2505C28.6215 25.4605 32.211 21.8855 32.211 17.5C32.211 13.129 28.636 9.53949 24.2505 9.53949H22.0649"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3948 9.53949H11.2237C6.83818 9.53949 3.26318 13.1145 3.26318 17.5C3.26318 21.8711 6.83818 25.4605 11.2237 25.4605H13.3948"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9473 17.5H23.5262"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
